// This is the main component of the whole application (the parent component after login), it consists of 2 main parts:
// 1) Navigation Menu and its content
// 2) Dashboard content (the pages and content displayed in each page of the dashboard)
// The content pages are imported as Routes here and have their own components(imported at thge top level
// of this component). Displaying them according to the page route(location of the user e.g. "/securitySettings")
// is handled with React Router Switch components. When the route matches a component it renders the component

import React, { useState, useEffect, useRef } from "react";
import Navbar from "../../Dashboard/Components/Navbar/Menu";
import Settings from "../../Dashboard/Components/Settings/Settings";
import { Switch, Route, BrowserRouter, NavLink } from "react-router-dom";
import ESSHome from "../../Dashboard/Components/Home/ESSHome/ESSHome";
import Talents from "../../Dashboard/Components/Talents/Talents";
import EmployeeList from "../../Dashboard/Components/Employees/EmloyeeList";
import "../../../Assets/Styles/Dashboard.scss";
import "../../../Assets/Styles/DashboardPages.scss";
import "../../../Assets/Styles/BlueRoundedCheckbox.scss";
import DashboardHead from "../../Dashboard/Components/ShareElements/DashboardHead/DashboardHead";
import ACLsRoutes from "./SecuritySettings/ACLs/ACLs";
import UserManagementRoutes from "./SecuritySettings/UserManagement/UserManagement";
import SecurityProfilesRoutes from "./SecuritySettings/SecurityProfiles/SecurityProfiles";
import "../../../Assets/Styles/SecuritySettings.scss";
import MobileNav from "../../Dashboard/Components/Navbar/MobileNav/MobileNav";
import ApplicationSettings from "./SyestemSettings/ApplicationSettings";
import InactivityModal from "../../Dashboard/Components/ShareElements/InactivityModal/InactivityModal";
import { Config } from "../../../Config";
import ConfirmationAlert from "../../Dashboard/Components/ShareElements/Alert/Alert";
import axios from "axios";
import DataImport from "./AI/DataImport";
import DataImportHistory from "./AI/DataImportHistory";
import EmployeesProfile from "../../Dashboard/Components/Employees/EmployeeProfile";
import PositionsList from "../../Dashboard/Components/Positions/PositionsList";
import PositionsDetails from "../../Dashboard/Components/Positions/PositionDetails";
import Localization from "./SyestemSettings/Localization";
import Vacancies from "../../Dashboard/Components/Vacancies/Vacancies";
import JobDetails from "../../Dashboard/Components/RecruiterJPAdetails/JobDetails";
import Projects from "../../Dashboard/Components/Projcets/Projects";
import Activities from "../../Dashboard/Components/Activities/Activities";
import ProjectDetails from "../../Dashboard/Components/RecruiterJPAdetails/ProjectDetails";
import ActivityDetails from "../../Dashboard/Components/RecruiterJPAdetails/ActivityDetails";
import ManualJobs from "../../Dashboard/Components/ManualJPAs/ManualJobs";
import ManualProjects from "../../Dashboard/Components/ManualJPAs/ManualProjects";
import ManualActivities from "../../Dashboard/Components/ManualJPAs/ManualActivities";
import CreateJobs from "../../Dashboard/Components/ManualJPAs/CreateJPAs/CreateJobs";
import CreateProjects from "../../Dashboard/Components/ManualJPAs/CreateJPAs/CreateProjects";
import CreateActivities from "../../Dashboard/Components/ManualJPAs/CreateJPAs/CreateActivities";
import JobCandidates from "../../Dashboard/Components/ManualJPAs/Candidates/JobCandidates";
import ProjectCandidates from "../../Dashboard/Components/ManualJPAs/Candidates/ProjectCandidates";
import ActivityCandidates from "../../Dashboard/Components/ManualJPAs/Candidates/ActivityCandidates";
import Communication from "../../Dashboard/Components/Communication (ICP)/Communication";
import Notifications from "../../Dashboard/Components/Notifications/Notifications";
import EditProfile from "../../Dashboard/Components/EditProfile/EditProfile";
import {
  handleExpiredToken,
  minutesToMilliseconds,
} from "../../../Helper_functions";
import DashboardPages from "../../Dashboard/Components/DashboardPage/AvailableJPAs/DashboardPage";
import Chatbot from "../../Dashboard/Components/Chatbot/Chatbot";
import SystemMetrics from "./SyestemSettings/SystemMetrics";
import PhotoUploader from "../../Dashboard/Components/AI/PhotoUploader/PhotoUploader";
import UserGuide from "../../Dashboard/Components/UserGuide/UserGuide";
import ImagePreloader from "../../Dashboard/Components/ShareElements/ImagePreloader/ImagePreloader";
import WalkthroughImage from "../../../Assets/Images/Welcome-modal-banner.svg";
import ServiceMonitoring from "./SyestemSettings/ServiceMonitoring";
import MSSHome from "../../Dashboard/Components/Home/ESSHome/MSSHome";
import Assistify from "../../Dashboard/Components/AI/Assistify/Assistify";

const Home = () => {
  const SessionTimeoutRef = useRef(null);

  const [DeviceIsMobile, setDeviceIsMobile] = useState(false); // state boolean for user's device being mobile or desktop
  const [UserIsInactive, setUserIsInactive] = useState(false);
  const [UserHasAccess, setUserHasAccess] = useState(true);
  const [LangConfig, setLangConfig] = useState({});
  const [LangData, setLangData] = useState();
  const [SelectedLanguageName, setSelectedLanguageName] = useState("EN");
  const [UserInfo, setUserInfo] = useState();
  const [IsESS, setIsESS] = useState(true);
  const [HasESS, setHasESS] = useState(false); // determines if the user has ESS profile alongside with other profile types.
  const [IsCXAdmin, setIsCXAdmin] = useState(false);
  const [IsHRAdmin, setIsHRAdmin] = useState(false);
  const [IsMSS, setIsMSS] = useState(false);
  const [IsSuperAdmin, setIsSuperAdmin] = useState(false);
  const [NotifIsOpen, setNotifIsOpen] = useState(false);
  const [HasChatNotifications, setHasChatNotifications] = useState(false);
  const [HasEventsNotifications, setHasEventsNotifications] = useState(false);
  const [ChatNotifications, setChatNotifications] = useState([]);
  const [EventNotifications, setEventNotifications] = useState([]);
  const [ConfirmLogoutIsOpen, setConfirmLogoutIsOpen] = useState(false);
  const [UnreadEventsNotifs, setUnreadEventsNotifs] = useState(0);
  const [UnreadMessagesNotifs, setUnreadMessagesNotifs] = useState(0);
  const [ChatbotIsOpen, setChatbotIsOpen] = useState(false);
  const [GuideIsOpen, setGuideIsOpen] = useState(false);
  const [HR_MSS_AdminGuideIsOpen, setHR_MSS_AdminGuideIsOpen] = useState(false);
  const [JPATabsGuideIsOpen, setJPATabsGuideIsOpen] = useState(false);
  const [JPAItemsGuideIsOpen, setJPAItemsGuideIsOpen] = useState(false);
  const [BookmarkedItemsGuideIsOpen, setBookmarkedItemsGuideIsOpen] =
    useState(false);
  const [FooterJPAsGuideIsOpen, setFooterJPAsGuideIsOpen] = useState(false);
  const [NavBookmarksGuideIsOpen, setNavBookmarksGuideIsOpen] = useState(false);
  const [UserProfileGuideIsOpen, setUserProfileGuideIsOpen] = useState(false);
  const [SkillRecomGuideIsOpen, setSkillRecomGuideIsOpen] = useState(false);
  const [HeaderGuideIsOpen, setHeaderGuideIsOpen] = useState(false);
  const [LangDataInfo, setLangDataInfo] = useState(); // used for getting userId and previously saved preferences for updating user's selected language request
  const [DeviceInfo] = useState(
    window.navigator.userAgent.split(/\(([^)]+)\)/)[1]
  );
  const [ChangedCandidateBookmark, setChangedCandidateBookmark] = useState({
    id: "",
    isBookmarked: null,
  });
  const [ChangedJPAReaction, setChangedJPAReaction] = useState({
    id: "",
    reactionType: null,
    isBookmarked: false,
  });
  const [ChatbotType, setChatbotType] = useState("CX_BOT"); // "CX_BOT" or "ASK_ME_BOT"
  const [ICPKey, setICPKey] = useState(0);
  const [HasCXAdminOnly, setHasCXAdminOnly] = useState(false);

  var stompClient = null;
  var UserId;

  useEffect(() => {
    if (window.innerWidth <= 450) {
      setDeviceIsMobile(true);
    }
    checkFirstLogin(); // checks if the user has logged in for the first time
    checkWizardStatus();
    checkMenuItemsLength();
    getUserInfo();
    checkAuthorization();
    getTimeoutDuration(); // on page initializaion gets the timeout duration
    startCheckingLogoutDuration(); // checks the timeout duration every 50 seconds
    getSelectedLanguage(); // The main selected language by superadmin
    fetchICPNotifications(); // fetches the messages tab items on the notifications
    fetchEventsNotifications(); // fetches the events tab items on the notifications
    startListeningNotifs();
    startListeningLanguageChange();
    fetchSaveLangData();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const startListeningLanguageChange = () => {
    setInterval(() => {
      if (window.localStorage.getItem("LangChanged") !== null) {
        handleUserSelectedLanguage();
        window.localStorage.removeItem("LangChanged");
      }
    }, 1000);
  };

  const startListeningNotifs = () => {
    setInterval(() => {
      fetchEventsNotifications();
      setTimeout(() => {
        fetchICPNotifications();
      }, 300);
    }, 5000);
  };

  const handleUserSelectedLanguage = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/language/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        fetchUserPreferences(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const checkFirstLogin = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/passed-walkthrough",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setGuideIsOpen(!Res.data.passedWalkthrough);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const updateWalkthroughStatus = (PassedWalkthrough) => {
    if (PassedWalkthrough === false) {
      document.getElementById("back-to-home-navlink").click();
      setGuideIsOpen(true);
    }
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/passed-walkthrough",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: UserInfo.id,
        username: UserInfo.username,
        passedWalkthrough: PassedWalkthrough,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const restartChatbot = (Id) => {
    let Req = {
      method: "POST",
      baseURL: "https://dev-rasa.connexing.io/webhooks/rest/webhook",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sender: Id + `(${DeviceInfo})`,
        message: "/restart",
        metadata: { token: window.localStorage.getItem("Token") },
      },
    };

    if (window._env_.API_URL === "https://qa-apigateway.connexing.io") {
      Req.baseURL = "https://qa-rasa.connexing.io/webhooks/rest/webhook";
    }

    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchUserPreferences = (AllLanguages) => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user-info",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        saveUserLanguage(Res.data.language);
        window.localStorage.setItem("ActiveLang", Res.data.language);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const saveUserLanguage = (SelectedLanguageName) => {
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/labels/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          labelValueLike: "",
          language: SelectedLanguageName,
        },
        size: 10000,
        start: 0,
      },
    };

    setSelectedLanguageName(SelectedLanguageName);

    axios(Req)
      .then((Res) => {
        console.log(Res);
        let LangDataArray = [];
        Res.data.results.map((Item) => {
          Item.labelValues.map((LabelItem) => {
            if (SelectedLanguageName === LabelItem.language) {
              LangDataArray.push({
                label_id: Item.labelId,
                label_value: LabelItem.labelText,
                label_category: Item.labelCategory,
              });
            }
          });
        });
        setLangData(LangDataArray);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchEventsNotifications = () => {
    let ReqData = {
      start: 0,
      size: 100,
      sorts: [
        {
          fieldName: "notificationTime",
          direction: "DESC",
        },
      ],
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/events/search",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: ReqData,
    };
    axios(Req)
      .then((Res) => {
        setEventNotifications(Res.data.results);
        handleUnreadStatus(Res.data.results, "events");
        let others = [];
        Res.data.results.map((Item) => {
          if (
            Item.source === "AI_OFFLINE_RECOMMENDATION" ||
            Item.source === "AI_ONLINE_RECOMMENDATION"
          ) {
            others.push(Item);
          }
        });

        // unread notifications count
        let Count = 0;
        Res.data.results.map((Notif) => {
          if (Notif.status === "UNREAD") {
            Count++;
          }
        });
        setUnreadEventsNotifs(Count);
      })
      .catch((Err) => {
        console.log(Err.response);
        //expired token will throw 404
        if (Err.response.status === 404) {
          handleExpiredToken();
        }
      });
  };

  const fetchICPNotifications = () => {
    let ReqData = {
      start: 0,
      size: 100,
      sorts: [
        {
          fieldName: "notificationTime",
          direction: "DESC",
        },
      ],
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/messages/search",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: ReqData,
    };
    axios(Req)
      .then((Res) => {
        setChatNotifications(Res.data.results);
        handleUnreadStatus(Res.data.results, "messages");

        // unread notifications count
        let Count = 0;
        Res.data.results.map((Notif) => {
          if (Notif.status === "UNREAD") {
            Count++;
          }
        });
        setUnreadMessagesNotifs(Count);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleUnreadStatus = (NotifList, Type) => {
    let Statuses = [];
    NotifList.map((Notif) => {
      Statuses.push(Notif.status);
    });
    if (Type === "messages") {
      if (Statuses.includes("UNREAD")) {
        setHasChatNotifications(true);
      } else {
        setHasChatNotifications(false);
      }
    } else {
      if (Statuses.includes("UNREAD")) {
        setHasEventsNotifications(true);
      } else {
        setHasEventsNotifications(false);
      }
    }
  };

  const conncetWebSocket = () => {
    const Stomp = require("stompjs");
    var SockJS = require("sockjs-client");
    SockJS = new SockJS(
      window._env_.API_URL + Config.NotificationService + "/ws-notif",
      null,
      { transports: ["xhr-polling"] }
    );
    stompClient = Stomp.over(SockJS);
    // stompClient.connect({}, onConnected, onError);
  };

  const onConnected = () => {
    console.log("connected");
    stompClient.subscribe(
      "/user/" + UserId + "/queue/messages/chat",
      onMessageReceived
    );
    stompClient.subscribe(
      "/user/" + UserId + "/queue/messages/event",
      onMessageReceived
    );
  };

  const onError = (err) => {
    console.log(err);
  };

  const onMessageReceived = (Message) => {
    let MessageBody = JSON.parse(Message.body);
    if (MessageBody.type === "CHAT") {
      fetchICPNotifications();
    } else {
      fetchEventsNotifications();
    }
  };

  const checkWizardStatus = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/profile/first-wizard",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.firstWizard === true || Res.data.firstWizard === null) {
          if (Res.data.username !== "superadmin") {
            window.location.assign("/SetupWizard");
          }
        } else {
          return null;
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/profile",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        handleUserRoleType(Res.data);
        setUserInfo(Res.data);
        restartChatbot(Res.data.id);
        checkUserAccessToRoute(Res.data);

        //Checking if user is superadmin
        if (Res.data.superAdmin) {
          setIsSuperAdmin(true);
        }

        UserId = Res.data.id;

        // conncetWebSocket() connects to the web socket to fetch the logged-in user's notifications
        // after fetching their info and passing the user's UUID
        // conncetWebSocket();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleUserRoleType = (UserInfo) => {
    let Types = [];
    UserInfo.roles.map((Role) => {
      Types.push(Role.roleType);
    });
    if (Types.includes("EMPLOYEE_SELF_SERVICE") && Types.length === 1) {
      setIsESS(true);
    } else if (Types.includes("HR_ADMIN")) {
      setIsHRAdmin(true);
    }
    if (Types.includes("EMPLOYEE_SELF_SERVICE")) {
      setHasESS(true);
    }

    // Checking if the user has role type 'MANAGER_SELF_SERVICE'
    if (Types.includes("MANAGER_SELF_SERVICE")) {
      setIsMSS(true);
      setIsESS(false);
    }

    if (Types.length === 1 && Types.includes("CX_ADMIN")) {
      setHasCXAdminOnly(true);
    }
  };

  const checkMenuItemsLength = () => {
    if (document.getElementById("page-wrapper") !== null) {
      if (window.localStorage.getItem("MenuIsEmpty") === "1") {
        document.getElementById("page-wrapper").classList.add("full-width-ess"); // ess has no menu so the styles are different
        clearInterval(CheckInterval);
      }
    }
  };
  let CheckInterval = setInterval(checkMenuItemsLength, 100);

  // superadmin set language is fetched by this function
  const getSelectedLanguage = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/language",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setLangData(Res.data);
        handleUserSelectedLanguage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  // Getting a list of user's access-granted routes and checking if they have access to
  // the current window location (to avoid manual access to present routes to which the user has no access)
  const checkUserAccessToRoute = (UserInfoData) => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/scope",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.length === 0) {
          window.localStorage.setItem("MenuIsEmpty", 1); // 1:true 0:false
        } else {
          window.localStorage.setItem("MenuIsEmpty", 0); // 1:true 0:false
        }
        let UserRoutes = [
          "/home",
          "/home/",
          "/home/ess",
          "/home/ess/",
          "/home/communication",
          "/home/editNotifications",
          "/home/editProfile",
          "/home/editNotifications/",
          "/home/editProfile/",
          "/home/employeeDashboard",
          "/home/employeeDashboard/",
        ]; // all users have these routes
        Res.data.map((Item) => {
          // exception for security profiles route for non-superadmin users
          // to prevent them from acessing security profiles form.
          if (Item.route === "/securityProfiles") {
            if (UserInfoData.superAdmin) {
              UserRoutes.push("/home" + Item.route);
            }
          } else {
            // all other routes
            UserRoutes.push("/home" + Item.route);
          }
        });

        if (UserRoutes.includes("/home/vacancies")) {
          UserRoutes.push("/home/JobDetails/");
        }

        if (UserRoutes.includes("/home/createVacancies")) {
          UserRoutes.push("/home/addNewVacancy");
          UserRoutes.push("/home/vacancyCandidates");
        }
        if (UserRoutes.includes("/home/createProjects")) {
          UserRoutes.push("/home/addNewProject");
          UserRoutes.push("/home/projectCandidates");
        }
        if (UserRoutes.includes("/home/createActivities")) {
          UserRoutes.push("/home/addNewActivity");
          UserRoutes.push("/home/activityCandidates");
        }

        // Checking user roles to see if it contains a security
        // profile with type "CX_ADMIN" then they will have acceess
        // to "/systemMetrics" route on the application. There is a
        // state in this component named "IsCXAmin" which is set to
        // false by default and will be set to true if the user has
        // this role type. The state is used for displaying the page
        // to the user before this logic is executed (in case it is
        // entered on browser location bar).
        let RoleTypes = [];
        UserInfoData.roles.map((Role) => {
          RoleTypes.push(Role.roleType);
        });
        if (RoleTypes.includes("CX_ADMIN")) {
          setIsCXAdmin(true);
        }

        if (!UserRoutes.includes(window.location.pathname)) {
          window.history.back();
        } else {
          setUserHasAccess(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const startCheckingLogoutDuration = () => {
    setInterval(() => {
      getTimeoutDuration();
    }, 150000);
  };

  const getTimeoutDuration = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/session-timeout",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        var Filter = "name";
        var Keyword = "SESSION_TIMEOUT_MINUTES";
        var Timeout = Res.data.filter((Obj) => {
          return Obj[Filter] === Keyword;
        });
        window.localStorage.setItem(
          "TimeoutDuration",
          minutesToMilliseconds(Timeout[0].value)
        );

        let LogoutOnExit = Res.data.filter((Item) => {
          return Item.name === "SESSION_ENDED_ON_BROWSER_CLOSED";
        });
        // handling browser local storage clearing for user's JWT tokens to
        // control automatic login.
        if (LogoutOnExit[0].value == "true") {
          window.localStorage.setItem("SESSION_ENDED_ON_BROWSER_CLOSED", true);
        } else {
          window.localStorage.setItem("SESSION_ENDED_ON_BROWSER_CLOSED", false);
        }

        var Language = Res.data.filter((Obj) => {
          return Obj["name"] === "LANGUAGE";
        });
        setLangConfig(Language[0]);
      })
      .catch((Err) => {
        console.log(Err);
        if (Err.response.status === 401) {
          console.log("timeout failed to respond");
          handleExpiredToken();
        }
      });
  };
  const checkAuthorization = () => {
    if (window.localStorage.getItem("Token") === null) {
      window.location.assign("/");
    }
  };

  const detectClicks = () => {
    let Duration = parseInt(window.localStorage.getItem("TimeoutDuration"));
    if (SessionTimeoutRef.current) {
      clearTimeout(SessionTimeoutRef.current);
    }
    SessionTimeoutRef.current = setTimeout(() => {
      logoutInactiveUser();
    }, Duration);
  };
  const logoutInactiveUser = () => {
    window.localStorage.removeItem("Token");
    window.localStorage.removeItem("RefreshToken");
    window.localStorage.removeItem("notification_jpa_search_data");
    window.localStorage.setItem("TimeoutDuration", "reached");
    setUserIsInactive(true);
  };
  const loginAgain = () => {
    window.location.assign("/");
  };
  const detectCursorMove = () => {
    let Duration = parseInt(window.localStorage.getItem("TimeoutDuration"));
    if (SessionTimeoutRef.current) {
      clearTimeout(SessionTimeoutRef.current);
    }
    SessionTimeoutRef.current = setTimeout(() => {
      logoutInactiveUser();
    }, Duration);

    window.onscroll = () => {
      detectScroll();
    };
  };
  const detectScroll = () => {
    let Duration = parseInt(window.localStorage.getItem("TimeoutDuration"));
    if (SessionTimeoutRef.current) {
      clearTimeout(SessionTimeoutRef.current);
    }
    SessionTimeoutRef.current = setTimeout(() => {
      logoutInactiveUser();
    }, Duration);
  };
  const detectKeyPress = () => {
    let Duration = parseInt(window.localStorage.getItem("TimeoutDuration"));
    if (SessionTimeoutRef.current) {
      clearTimeout(SessionTimeoutRef.current);
    }
    SessionTimeoutRef.current = setTimeout(() => {
      logoutInactiveUser();
    }, Duration);
  };

  const openNotifications = () => {
    setNotifIsOpen(true);
  };
  const closeNotifications = () => {
    setNotifIsOpen(false);
  };

  // Logout process:
  // 1) send a restart request to chatbot
  // 2)  clear JWT tokens from localStorage and redirect to the root page
  const handleLogout = () => {
    // The API request is to restart send a restart prompt to the chatbot to prevent its confusion in next login
    let Req = {
      method: "POST",
      baseURL: window._env_.RASA_URL + "/webhooks/rest/webhook",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sender: UserInfo.id + `(${DeviceInfo})`,
        message: "/restart",
        metadata: { token: window.localStorage.getItem("Token") },
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        window.localStorage.removeItem("Token");
        window.localStorage.removeItem("MenuIsOpen");
        window.localStorage.removeItem("notification_jpa_search_data");
        window.location.assign("/");
      })
      .catch((Err) => {
        console.log(Err);
        window.localStorage.removeItem("Token");
        window.localStorage.removeItem("MenuIsOpen");
        window.localStorage.removeItem("notification_jpa_search_data");
        window.location.assign("/");
      });
  };

  const toggleChatbot = () => {
    setChatbotIsOpen(!ChatbotIsOpen);
    setChatbotType("CX_BOT");
  };

  const handleRefreshChatbotCandidateBookmark = (id, isBookmarked) => {
    setChangedCandidateBookmark({ id, isBookmarked });
  };

  const handleJPAReaction = (reactionId, type, isBookmarked) => {
    setChangedJPAReaction({
      id: reactionId,
      reactionType: type,
      isBookmarked,
    });
  };

  // Requesting user info to fill in the user's paths, countryId, etc. data when saving the user's
  // new selected language
  const fetchSaveLangData = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user-info",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setLangDataInfo(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const savePreferredLanguage = (Lang) => {
    setSelectedLanguageName(Lang);

    let Data = {
      id: LangDataInfo.id,
      countryId: LangDataInfo.countryId,
      anonymous: LangDataInfo.anonymous,
      path: LangDataInfo.path,
      language: Lang,
    };

    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/user-info/preferences",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        handleUserSelectedLanguage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const toggleFourthGuide = () => {
    setFooterJPAsGuideIsOpen(true);
    setNavBookmarksGuideIsOpen(false);
  };
  const toggleSixthGuide = () => {
    setNavBookmarksGuideIsOpen(false);
    setUserProfileGuideIsOpen(true);
    setSkillRecomGuideIsOpen(false);
  };
  const toggleSeventhGuide = () => {
    setSkillRecomGuideIsOpen(true);
    setHeaderGuideIsOpen(false);
  };

  const closeGuide = () => {
    setHR_MSS_AdminGuideIsOpen(false);
    setGuideIsOpen(false);
    setJPATabsGuideIsOpen(false);
    setJPAItemsGuideIsOpen(false);
    setBookmarkedItemsGuideIsOpen(false);
    setFooterJPAsGuideIsOpen(false);
    setNavBookmarksGuideIsOpen(false);
    setUserProfileGuideIsOpen(false);
    setSkillRecomGuideIsOpen(false);
    setHeaderGuideIsOpen(false);
  };

  // skip user guide
  const skipWalkThrough = () => {
    updateWalkthroughStatus(true);
    setGuideIsOpen(false);
  };

  // This function is used across UserGuide components for
  // jumping to a specific step on the user guide (Walkthrough)
  const jumpToStep = (Step) => {
    if (!GuideIsOpen) {
      setGuideIsOpen(false);
    }

    if (window.location.pathname !== "/home/ess") {
      if (IsSuperAdmin || IsHRAdmin || IsMSS) {
        document.getElementById("link-to-ess-home-navlink").click();
      }
    }

    // Applying the selected step states and setting all others
    // to "false" so they will not be displayed
    if (Step === 0) {
      document.getElementById("back-to-home-navlink").click();

      setHR_MSS_AdminGuideIsOpen(true);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(false);
    } else if (Step === 1) {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(true);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(false);
    } else if (Step === 2) {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(true);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(false);
    } else if (Step === 3) {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(true);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(false);
    } else if (Step === 4) {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(true);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(false);
    } else if (Step === 5) {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(true);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(false);
    } else if (Step === 6) {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(true);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(false);
    } else if (Step === 7) {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(true);
      setHeaderGuideIsOpen(false);
    } else {
      setHR_MSS_AdminGuideIsOpen(false);
      setJPATabsGuideIsOpen(false);
      setJPAItemsGuideIsOpen(false);
      setBookmarkedItemsGuideIsOpen(false);
      setFooterJPAsGuideIsOpen(false);
      setNavBookmarksGuideIsOpen(false);
      setUserProfileGuideIsOpen(false);
      setSkillRecomGuideIsOpen(false);
      setHeaderGuideIsOpen(true);
    }
  };

  const toggleAskMeBot = async () => {
    // change chatbottype first before opening chatbot to makesure sliding animation runs smoothly
    await setChatbotType("ASK_ME_BOT");
    setChatbotIsOpen(!ChatbotIsOpen);
  };

  // changes the defined key for ICP component to reload it with new props
  // and variables in case it is needed (such as when the user is already on
  // ICP and clicks on a notification item and we need to open a specific chat)
  const toggleRemountICP = () => {
    // Increment the key to trigger a remount of the component
    setICPKey((prevKey) => prevKey + 1);
  };

  return (
    <BrowserRouter basename="/home">
      <ImagePreloader Images={[WalkthroughImage]} />
      <NavLink id="back-to-home-navlink" hidden to="/"></NavLink>
      <NavLink id="link-to-ess-home-navlink" hidden to="/ess"></NavLink>
      <NavLink id="to-job-details" to="/JobDetails" hidden></NavLink>
      <NavLink id="to-project-details" to="/ProjectDetails" hidden></NavLink>
      <NavLink id="to-activity-details" to="/ActivityDetails" hidden></NavLink>
      <NavLink id="to-job-candidates" to="/vacancyCandidates" hidden></NavLink>
      <NavLink hidden to="/editProfile" id="edit-profile-nav-link"></NavLink>
      <NavLink
        id="to-project-candidates"
        to="/projectCandidates"
        hidden
      ></NavLink>
      <NavLink
        id="to-activity-candidates"
        to="/activityCandidates"
        hidden
      ></NavLink>
      {UserIsInactive ? (
        <InactivityModal LangData={LangData} loginAgain={() => loginAgain()} />
      ) : null}
      {UserHasAccess || LangData !== undefined ? (
        <div
          className="page-content"
          onClick={() => detectClicks()}
          onMouseMove={() => {
            detectCursorMove();
          }}
          onKeyPress={() => detectKeyPress()}
        >
          {ConfirmLogoutIsOpen ? (
            <ConfirmationAlert
              AlertText={translateText("logout_modal_header")}
              AlertInfo={translateText("logout_modal_body")}
              AcceptText={translateText("logout")}
              CancelText={translateText("cancel")}
              IsDelete={false}
              cancel={() => setConfirmLogoutIsOpen(false)}
              accept={() => handleLogout()}
            />
          ) : null}
          {DeviceIsMobile && UserInfo !== undefined ? (
            <MobileNav
              UserInfo={UserInfo}
              LangData={LangData}
              UnreadEventsNotifs={UnreadEventsNotifs}
              UnreadMessagesNotifs={UnreadMessagesNotifs}
              HasNotifications={
                HasChatNotifications || HasEventsNotifications ? true : false
              }
              ToggleNotifications={() => openNotifications()}
              setConfirmLogoutIsOpen={(Bool) => setConfirmLogoutIsOpen(Bool)}
              ToggleChatbot={toggleChatbot}
              UserLanguage={SelectedLanguageName}
              SetPreferredLanguage={(Lang) => savePreferredLanguage(Lang)}
              HandleUserSelectedLanguage={() => handleUserSelectedLanguage()}
              NavBookmarksGuideIsOpen={NavBookmarksGuideIsOpen}
              SetNavBookmarksGuideIsOpen={(Bool) =>
                setNavBookmarksGuideIsOpen(Bool)
              }
              ToggleSixthGuide={() => toggleSixthGuide()}
              ToggleFourthGuide={() => toggleFourthGuide()}
              HeaderGuideIsOpen={HeaderGuideIsOpen}
              SetHeaderGuideIsOpen={(Bool) => setHeaderGuideIsOpen(Bool)}
              ToggleSeventhGuide={() => toggleSeventhGuide()}
              CloseGuide={() => closeGuide()}
              JumpToStep={(Step) => jumpToStep(Step)}
              UpdateWalkthrough={(Bool) => updateWalkthroughStatus(Bool)}
              ToggleAskMeBot={() => toggleAskMeBot()}
            />
          ) : (
            <div className="nav-header" id="nav-header">
              <div id="navigation-menu" className="navigation-menu">
                <Navbar
                  LangData={LangData}
                  UserInfo={UserInfo}
                  setConfirmLogoutIsOpen={(Bool) =>
                    setConfirmLogoutIsOpen(Bool)
                  }
                  NavBookmarksGuideIsOpen={NavBookmarksGuideIsOpen}
                  SetNavBookmarksGuideIsOpen={(Bool) =>
                    setNavBookmarksGuideIsOpen(Bool)
                  }
                  ToggleSixthGuide={() => toggleSixthGuide()}
                  ToggleFourthGuide={() => toggleFourthGuide()}
                  JumpToStep={(Step) => jumpToStep(Step)}
                  CloseGuide={() => closeGuide()}
                  HasAdditionalStep={
                    IsSuperAdmin || IsHRAdmin || IsMSS ? true : false
                  }
                />
              </div>
            </div>
          )}
          <React.Fragment>
            {LangData === undefined || UserInfo === undefined ? null : (
              <React.Fragment>
                {GuideIsOpen ? (
                  <UserGuide
                    Skip={() => skipWalkThrough()}
                    HasAdditionalStep={
                      IsSuperAdmin || IsHRAdmin || IsMSS ? true : false
                    }
                    setJPATabsGuideIsOpen={(Bool) =>
                      setJPATabsGuideIsOpen(Bool)
                    }
                    setAdminHomeGuideIsOpen={(Bool) =>
                      setHR_MSS_AdminGuideIsOpen(Bool)
                    }
                    LangData={LangData}
                  />
                ) : null}
                <div className="dashboard-content" id="page-wrapper">
                  <div id="dashboard-content">
                    <DashboardHead
                      LangData={LangData}
                      UserInfo={UserInfo}
                      UserLanguage={SelectedLanguageName}
                      UnreadEventsNotifs={UnreadEventsNotifs}
                      UnreadMessagesNotifs={UnreadMessagesNotifs}
                      SetPreferredLanguage={(Lang) =>
                        savePreferredLanguage(Lang)
                      }
                      HandleUserSelectedLanguage={() =>
                        handleUserSelectedLanguage()
                      }
                      HasNotifications={
                        HasChatNotifications || HasEventsNotifications
                          ? true
                          : false
                      }
                      ToggleNotifications={() => openNotifications()}
                      ToggleChatbot={() => toggleChatbot()}
                      ToggleAskMeBot={() => toggleAskMeBot()}
                      HeaderGuideIsOpen={HeaderGuideIsOpen}
                      SetHeaderGuideIsOpen={(Bool) =>
                        setHeaderGuideIsOpen(Bool)
                      }
                      ToggleSeventhGuide={() => toggleSeventhGuide()}
                      CloseGuide={() => closeGuide()}
                      JumpToStep={(Step) => jumpToStep(Step)}
                      UpdateWalkthrough={(Bool) =>
                        updateWalkthroughStatus(Bool)
                      }
                      NavBookmarksGuideIsOpen={NavBookmarksGuideIsOpen}
                      HasAdditionalStep={
                        IsSuperAdmin || IsHRAdmin || IsMSS ? true : false
                      }
                    />
                    {NotifIsOpen ? (
                      <Notifications
                        Close={() => closeNotifications()}
                        ChatNotifications={ChatNotifications}
                        EventNotifications={EventNotifications}
                        UpdateMessagesList={() => fetchICPNotifications()}
                        UpdateEventsList={() => fetchEventsNotifications()}
                        HasChatNotifications={HasChatNotifications}
                        HasEventsNotifications={HasEventsNotifications}
                        LangData={LangData}
                        IsMSS={IsMSS}
                        IsSuperAdmin={IsSuperAdmin}
                        RemountICP={() => toggleRemountICP()}
                      />
                    ) : null}
                    <Chatbot
                      Close={toggleChatbot}
                      IsOpen={ChatbotIsOpen}
                      LangData={LangData}
                      SetIsOpen={(Bool) => setChatbotIsOpen(Bool)}
                      UserInfo={UserInfo}
                      ChangedCandidateBookmark={ChangedCandidateBookmark}
                      ChangedJPAReaction={ChangedJPAReaction}
                      SetChatbotType={(Type) => setChatbotType(Type)}
                      ChatbotType={ChatbotType}
                    />
                    <Switch>
                      <Route path="/" exact>
                        <>
                          {HasCXAdminOnly && !IsSuperAdmin ? (
                            <ESSHome
                              LangData={LangData}
                              ToggleSixthGuide={() => toggleSixthGuide()}
                              JPATabsGuideIsOpen={JPATabsGuideIsOpen}
                              setJPATabsGuideIsOpen={(Bool) =>
                                setJPATabsGuideIsOpen(Bool)
                              }
                              JPAItemsGuideIsOpen={JPAItemsGuideIsOpen}
                              SetJPAItemsGuideIsOpen={(Bool) =>
                                setJPAItemsGuideIsOpen(Bool)
                              }
                              BookmarkedItemsGuideIsOpen={
                                BookmarkedItemsGuideIsOpen
                              }
                              SetBookmarkedItemsGuideIsOpen={(Bool) =>
                                setBookmarkedItemsGuideIsOpen(Bool)
                              }
                              FooterJPAsGuideIsOpen={FooterJPAsGuideIsOpen}
                              SetFooterJPAsGuideIsOpen={(Bool) =>
                                setFooterJPAsGuideIsOpen(Bool)
                              }
                              NavBookmarksGuideIsOpen={NavBookmarksGuideIsOpen}
                              SetNavBookmarksGuideIsOpen={(Bool) =>
                                setNavBookmarksGuideIsOpen(Bool)
                              }
                              UserProfileGuideIsOpen={UserProfileGuideIsOpen}
                              SetUserProfileGuideIsOpen={(Bool) =>
                                setUserProfileGuideIsOpen(Bool)
                              }
                              SkillRecomGuideIsOpen={SkillRecomGuideIsOpen}
                              SetSkillRecomGuideIsOpen={(Bool) =>
                                setSkillRecomGuideIsOpen(Bool)
                              }
                              HeaderGuideIsOpen={HeaderGuideIsOpen}
                              SetHeaderGuideIsOpen={(Bool) =>
                                setHeaderGuideIsOpen(Bool)
                              }
                              GetUserInfo={() => getUserInfo()}
                              handleJPAReaction={(
                                reactionId,
                                type,
                                isBookmarked
                              ) =>
                                handleJPAReaction(
                                  reactionId,
                                  type,
                                  isBookmarked
                                )
                              }
                              JumpToStep={(Step) => jumpToStep(Step)}
                              CloseGuide={() => closeGuide()}
                              IsMSS={IsMSS}
                            />
                          ) : (
                            <>
                              {IsESS && !IsSuperAdmin ? (
                                <ESSHome
                                  LangData={LangData}
                                  ToggleSixthGuide={() => toggleSixthGuide()}
                                  JPATabsGuideIsOpen={JPATabsGuideIsOpen}
                                  setJPATabsGuideIsOpen={(Bool) =>
                                    setJPATabsGuideIsOpen(Bool)
                                  }
                                  JPAItemsGuideIsOpen={JPAItemsGuideIsOpen}
                                  SetJPAItemsGuideIsOpen={(Bool) =>
                                    setJPAItemsGuideIsOpen(Bool)
                                  }
                                  BookmarkedItemsGuideIsOpen={
                                    BookmarkedItemsGuideIsOpen
                                  }
                                  SetBookmarkedItemsGuideIsOpen={(Bool) =>
                                    setBookmarkedItemsGuideIsOpen(Bool)
                                  }
                                  FooterJPAsGuideIsOpen={FooterJPAsGuideIsOpen}
                                  SetFooterJPAsGuideIsOpen={(Bool) =>
                                    setFooterJPAsGuideIsOpen(Bool)
                                  }
                                  NavBookmarksGuideIsOpen={
                                    NavBookmarksGuideIsOpen
                                  }
                                  SetNavBookmarksGuideIsOpen={(Bool) =>
                                    setNavBookmarksGuideIsOpen(Bool)
                                  }
                                  UserProfileGuideIsOpen={
                                    UserProfileGuideIsOpen
                                  }
                                  SetUserProfileGuideIsOpen={(Bool) =>
                                    setUserProfileGuideIsOpen(Bool)
                                  }
                                  SkillRecomGuideIsOpen={SkillRecomGuideIsOpen}
                                  SetSkillRecomGuideIsOpen={(Bool) =>
                                    setSkillRecomGuideIsOpen(Bool)
                                  }
                                  HeaderGuideIsOpen={HeaderGuideIsOpen}
                                  SetHeaderGuideIsOpen={(Bool) =>
                                    setHeaderGuideIsOpen(Bool)
                                  }
                                  GetUserInfo={() => getUserInfo()}
                                  handleJPAReaction={(
                                    reactionId,
                                    type,
                                    isBookmarked
                                  ) =>
                                    handleJPAReaction(
                                      reactionId,
                                      type,
                                      isBookmarked
                                    )
                                  }
                                  JumpToStep={(Step) => jumpToStep(Step)}
                                  CloseGuide={() => closeGuide()}
                                  IsMSS={IsMSS}
                                />
                              ) : (
                                <MSSHome
                                  LangData={LangData}
                                  ToggleSixthGuide={() => toggleSixthGuide()}
                                  JPATabsGuideIsOpen={JPATabsGuideIsOpen}
                                  setJPATabsGuideIsOpen={(Bool) =>
                                    setJPATabsGuideIsOpen(Bool)
                                  }
                                  JPAItemsGuideIsOpen={JPAItemsGuideIsOpen}
                                  SetJPAItemsGuideIsOpen={(Bool) =>
                                    setJPAItemsGuideIsOpen(Bool)
                                  }
                                  BookmarkedItemsGuideIsOpen={
                                    BookmarkedItemsGuideIsOpen
                                  }
                                  SetBookmarkedItemsGuideIsOpen={(Bool) =>
                                    setBookmarkedItemsGuideIsOpen(Bool)
                                  }
                                  FooterJPAsGuideIsOpen={FooterJPAsGuideIsOpen}
                                  SetFooterJPAsGuideIsOpen={(Bool) =>
                                    setFooterJPAsGuideIsOpen(Bool)
                                  }
                                  NavBookmarksGuideIsOpen={
                                    NavBookmarksGuideIsOpen
                                  }
                                  SetNavBookmarksGuideIsOpen={(Bool) =>
                                    setNavBookmarksGuideIsOpen(Bool)
                                  }
                                  UserProfileGuideIsOpen={
                                    UserProfileGuideIsOpen
                                  }
                                  SetUserProfileGuideIsOpen={(Bool) =>
                                    setUserProfileGuideIsOpen(Bool)
                                  }
                                  SkillRecomGuideIsOpen={SkillRecomGuideIsOpen}
                                  SetSkillRecomGuideIsOpen={(Bool) =>
                                    setSkillRecomGuideIsOpen(Bool)
                                  }
                                  HeaderGuideIsOpen={HeaderGuideIsOpen}
                                  SetHeaderGuideIsOpen={(Bool) =>
                                    setHeaderGuideIsOpen(Bool)
                                  }
                                  AdminHomeGuideIsOpen={HR_MSS_AdminGuideIsOpen}
                                  setAdminHomeGuideIsOpen={(Bool) =>
                                    setHR_MSS_AdminGuideIsOpen(Bool)
                                  }
                                  GuideHasAdditionalStep={
                                    IsSuperAdmin || IsHRAdmin || IsMSS
                                      ? true
                                      : false
                                  }
                                  GetUserInfo={() => getUserInfo()}
                                  UserInfo={UserInfo}
                                  handleJPAReaction={(
                                    reactionId,
                                    type,
                                    isBookmarked
                                  ) =>
                                    handleJPAReaction(
                                      reactionId,
                                      type,
                                      isBookmarked
                                    )
                                  }
                                  JumpToStep={(Step) => jumpToStep(Step)}
                                  CloseGuide={() => closeGuide()}
                                />
                              )}
                            </>
                          )}
                        </>
                      </Route>
                      {IsMSS || IsSuperAdmin ? (
                        <Route path="/ess">
                          <ESSHome
                            LangData={LangData}
                            ToggleSixthGuide={() => toggleSixthGuide()}
                            JPATabsGuideIsOpen={JPATabsGuideIsOpen}
                            setJPATabsGuideIsOpen={(Bool) =>
                              setJPATabsGuideIsOpen(Bool)
                            }
                            JPAItemsGuideIsOpen={JPAItemsGuideIsOpen}
                            SetJPAItemsGuideIsOpen={(Bool) =>
                              setJPAItemsGuideIsOpen(Bool)
                            }
                            BookmarkedItemsGuideIsOpen={
                              BookmarkedItemsGuideIsOpen
                            }
                            SetBookmarkedItemsGuideIsOpen={(Bool) =>
                              setBookmarkedItemsGuideIsOpen(Bool)
                            }
                            FooterJPAsGuideIsOpen={FooterJPAsGuideIsOpen}
                            SetFooterJPAsGuideIsOpen={(Bool) =>
                              setFooterJPAsGuideIsOpen(Bool)
                            }
                            NavBookmarksGuideIsOpen={NavBookmarksGuideIsOpen}
                            SetNavBookmarksGuideIsOpen={(Bool) =>
                              setNavBookmarksGuideIsOpen(Bool)
                            }
                            UserProfileGuideIsOpen={UserProfileGuideIsOpen}
                            SetUserProfileGuideIsOpen={(Bool) =>
                              setUserProfileGuideIsOpen(Bool)
                            }
                            SkillRecomGuideIsOpen={SkillRecomGuideIsOpen}
                            SetSkillRecomGuideIsOpen={(Bool) =>
                              setSkillRecomGuideIsOpen(Bool)
                            }
                            HeaderGuideIsOpen={HeaderGuideIsOpen}
                            SetHeaderGuideIsOpen={(Bool) =>
                              setHeaderGuideIsOpen(Bool)
                            }
                            AdminHomeGuideIsOpen={HR_MSS_AdminGuideIsOpen}
                            setAdminHomeGuideIsOpen={(Bool) =>
                              setHR_MSS_AdminGuideIsOpen(Bool)
                            }
                            GuideHasAdditionalStep={
                              IsSuperAdmin || IsHRAdmin || IsMSS ? true : false
                            }
                            GetUserInfo={() => getUserInfo()}
                            handleJPAReaction={(
                              reactionId,
                              type,
                              isBookmarked
                            ) =>
                              handleJPAReaction(reactionId, type, isBookmarked)
                            }
                            JumpToStep={(Step) => jumpToStep(Step)}
                            CloseGuide={() => closeGuide()}
                            IsMSS={IsMSS}
                          />
                        </Route>
                      ) : null}
                      <Route path="/employeeDashboard">
                        <DashboardPages
                          IsCXAdmin={IsCXAdmin}
                          IsHRAdmin={IsHRAdmin}
                          IsESS={HasESS}
                          IsMSS={IsMSS}
                          IsSuperAdmin={IsSuperAdmin}
                          LangData={LangData}
                          UserInfo={UserInfo}
                        />
                      </Route>
                      <Route path="/settings" component={Settings} />
                      <Route path="/acls" exact>
                        <ACLsRoutes LangData={LangData} />
                      </Route>
                      <Route path="/userManagement" exact>
                        <UserManagementRoutes
                          UserInfo={UserInfo}
                          LangData={LangData}
                        />
                      </Route>

                      <Route path="/securityProfiles" exact>
                        <SecurityProfilesRoutes LangData={LangData} />
                      </Route>
                      <Route path="/talents" component={Talents} />
                      <Route path="/employeeList">
                        <EmployeeList LangData={LangData} />
                      </Route>
                      <Route
                        path="/employeeProfile"
                        component={EmployeesProfile}
                      />
                      <Route path="/positionList">
                        <PositionsList LangData={LangData} />
                      </Route>
                      <Route
                        path="/positionDetails"
                        component={PositionsDetails}
                      />
                      <Route path="/applicationSettings">
                        <ApplicationSettings LangData={LangData} />
                      </Route>
                      <Route path="/dataImport" exact>
                        <DataImport LangData={LangData} />
                      </Route>
                      <Route
                        path="/dataImportHistory"
                        component={DataImportHistory}
                        exact
                      >
                        <DataImportHistory LangData={LangData} />
                      </Route>
                      <Route path="/assistify" component={Assistify} exact>
                        <Assistify LangData={LangData} />
                      </Route>
                      <Route path="/localization">
                        <Localization
                          LangData={LangData}
                          UserLanguage={SelectedLanguageName}
                        />
                      </Route>
                      <Route path="/vacancies">
                        <Vacancies LangData={LangData} />
                      </Route>
                      <Route path="/JobDetails">
                        <JobDetails UserInfo={UserInfo} LangData={LangData} />
                      </Route>
                      <Route path="/ProjectDetails">
                        <ProjectDetails
                          UserInfo={UserInfo}
                          LangData={LangData}
                        />
                      </Route>
                      <Route path="/ActivityDetails">
                        <ActivityDetails
                          UserInfo={UserInfo}
                          LangData={LangData}
                        />
                      </Route>
                      <Route path="/projects">
                        <Projects LangData={LangData} />
                      </Route>
                      <Route path="/activities">
                        <Activities LangData={LangData} />
                      </Route>
                      <Route path="/createVacancies">
                        <ManualJobs LangData={LangData} />
                      </Route>
                      <Route path="/addNewVacancy">
                        <CreateJobs LangData={LangData} UserInfo={UserInfo} />
                      </Route>
                      <Route path="/vacancyCandidates">
                        <JobCandidates
                          LangData={LangData}
                          RefreshChatbotCandidateBookmark={(id, isBookmarked) =>
                            handleRefreshChatbotCandidateBookmark(
                              id,
                              isBookmarked
                            )
                          }
                        />
                      </Route>
                      <Route path="/createProjects">
                        <ManualProjects LangData={LangData} />
                      </Route>
                      <Route path="/addNewProject">
                        <CreateProjects
                          LangData={LangData}
                          UserInfo={UserInfo}
                        />
                      </Route>
                      <Route path="/projectCandidates">
                        <ProjectCandidates
                          LangData={LangData}
                          RefreshChatbotCandidateBookmark={(id, isBookmarked) =>
                            handleRefreshChatbotCandidateBookmark(
                              id,
                              isBookmarked
                            )
                          }
                        />
                      </Route>
                      <Route path="/createActivities">
                        <ManualActivities LangData={LangData} />
                      </Route>
                      <Route path="/addNewActivity">
                        <CreateActivities
                          LangData={LangData}
                          UserInfo={UserInfo}
                        />
                      </Route>
                      <Route path="/activityCandidates">
                        <ActivityCandidates
                          LangData={LangData}
                          RefreshChatbotCandidateBookmark={(id, isBookmarked) =>
                            handleRefreshChatbotCandidateBookmark(
                              id,
                              isBookmarked
                            )
                          }
                        />
                      </Route>
                      <Route path="/communication">
                        <Communication
                          IsEmployee={IsESS}
                          UserInfo={UserInfo}
                          IsSuperAdmin={IsSuperAdmin}
                          IsHRAdmin={IsHRAdmin}
                          IsMSS={IsMSS}
                          LangData={LangData}
                          key={ICPKey}
                        />
                      </Route>
                      <Route path="/editProfile">
                        <EditProfile UserInfo={UserInfo} LangData={LangData} />
                      </Route>
                      <Route path="/photoUploader">
                        <PhotoUploader LangData={LangData} />
                      </Route>
                      {IsCXAdmin || IsSuperAdmin ? (
                        <Route path="/systemMetrics">
                          <SystemMetrics LangData={LangData} />
                        </Route>
                      ) : null}
                      <Route path="/serviceMonitoring">
                        <ServiceMonitoring
                          LangData={LangData}
                          UserLanguage={SelectedLanguageName}
                        />
                      </Route>
                    </Switch>
                  </div>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </div>
      ) : null}
    </BrowserRouter>
  );
};

export default Home;
